<template>
  <v-row style="border-radius: 20px; border: 1px #abd1c6 solid" class="mx-0">
    <v-col cols="10" class="pl-7 pr-0">
      <h1 style="font-size: 16px; font-weight: 700">Foto</h1>
      <div
        class="d-flex overflow-x-auto mt-4"
        style="gap: 20px; border-right: 1px solid #abd1c6"
      >
        <img
          v-for="image in images"
          :key="image"
          :src="image"
          @click="openDialog(image)"
          style="
            border-radius: 15px;
            object-fit: cover;
            width: 400px;
            height: 200px;
            flex-shrink: 0;
          "
        />
      </div>
    </v-col>
    <v-col cols="2" class="d-flex flex-column">
      <div class="d-flex justify-space-between align-center">
        <h1 style="font-size: 16px; font-weight: 700">QR Code</h1>
        <v-icon @click="openQrDownload()">mdi-tray-arrow-down</v-icon>
      </div>
      <div class="d-flex justify-center align-center flex-grow-1">
        <QRCode
          :value="asset.id.toString()"
          level="M"
          render-as="svg"
          :size="125"
          class="qr-code mt-4"
        />
      </div>
    </v-col>
    <v-dialog v-model="dialog" max-width="80vw">
      <v-card>
        <v-img :src="imageUrl" max-height="80vh" contain />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="qrDialog"
      width="auto"
      max-width="1000px"
      class="rounded-xl"
    >
      <QRCodeDownloadComponent :asset="asset" />
    </v-dialog>
  </v-row>
</template>

<script>
import QRCode from "qrcode.vue";
import QRCodeDownloadComponent from "@/components/LayananAsset/QRCodeDownloadComponent.vue";

export default {
  components: {
    QRCode,
    QRCodeDownloadComponent,
  },
  props: ["images", "id", "asset"],
  methods: {
    openDialog(image) {
      this.imageUrl = image;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    openQrDownload() {
      this.qrDialog = true;
    },
  },
  data() {
    return {
      dialog: false,
      qrDialog: false,
    };
  },
};
</script>

<style></style>
